import * as actionTypes from '../types/report';

const initialState = {
  error: false,
  loading: false,
  okRequest: false,
  reportType: {
    data: [],
    loading: false
  },
  reportProductTypes: {
    data: [],
    loading: false
  },
  reportUsers: {
    data: [],
    loading: false
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_LIST_REPORTS:
      return { ...state };

    case actionTypes.GET_LIST_REPORTS_SUCCESS:
      return { ...state };

    case actionTypes.GET_LIST_REPORTS_FAIL:
      return { ...state };

    case actionTypes.GET_REPORT_CREATE:
    case actionTypes.GET_REPORT_CREATE_NEW:
      return {
        ...state,
        loading: true,
        error: false,
        okRequest: false
      };

    case actionTypes.GET_REPORT_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        okRequest: true
      };

    case actionTypes.GET_REPORT_CREATE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        okRequest: false
      };

    case actionTypes.SET_INITIAL_STATE_REPORT:
      return {
        ...initialState
      };

    case actionTypes.GET_REPORT_ERROR_CLOSE:
      return {
        ...state,
        error: false,
        okRequest: false
      };

    case actionTypes.GET_REPORT_TYPES:
      return {
        ...state,
        reportType: {
          data: [],
          loading: true
        }
      };
    case actionTypes.GET_REPORT_TYPES_SUCCESS:
      return {
        ...state,
        reportType: {
          data: payload,
          loading: false
        }
      };
    case actionTypes.GET_REPORT_TYPES_FAIL:
      return {
        ...state,
        reportType: {
          ...state.reportType,
          loading: false
        }
      };

    case actionTypes.GET_REPORT_PRODUCT_TYPES:
      return {
        ...state,
        reportProductTypes: {
          data: [],
          loading: true
        }
      };
    case actionTypes.GET_REPORT_PRODUCT_TYPES_SUCCESS:
      return {
        ...state,
        reportProductTypes: {
          data: payload,
          loading: false
        }
      };
    case actionTypes.GET_REPORT_PRODUCT_TYPES_FAIL:
      return {
        ...state,
        reportProductTypes: {
          ...state.reportProductTypes,
          loading: false
        }
      };

    case actionTypes.GET_REPORT_USERS:
      return {
        ...state,
        reportUsers: {
          data: [],
          loading: true
        }
      };
    case actionTypes.GET_REPORT_USERS_SUCCESS:
      return {
        ...state,
        reportUsers: {
          data: payload,
          loading: false
        }
      };
    case actionTypes.GET_REPORT_USERS_FAIL:
      return {
        ...state,
        reportUsers: {
          ...state.reportUsers,
          loading: false
        }
      };

    default:
      return state;
  }
};

export default reducer;
